import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts";
import { sortByMonthAndYear } from "../../util/sortCart";

function Chart({ manager, text }) {
  //console.log(manager);
  let monthlyData = [];
  if (manager.length !== 0) monthlyData = sortByMonthAndYear(manager);
  return (
    <div className="">
      <div>
        {/* <div className="text-[#9E9E9E]  py-2 px-6">{text}</div> */}
        <div className="  w-[97%] h-[300px] m-auto mt-[20px]">
          <ResponsiveContainer>
            <AreaChart
              // width={950}
              // height={height}
              data={monthlyData}
              // margin={{ top: 15 }}
            >
              <defs>
                <linearGradient id="in" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#739D00" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#739D00" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="out" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#ffc658" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#ffc658" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="ira" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#e91e63" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#e91e63" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="nati" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#8e24aa" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#8e24aa" stopOpacity={0} />
                </linearGradient>
                {/* <linearGradient id="shahar" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#9c27b0" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#9c27b0" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="ofek" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#00bcd4" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#00bcd4" stopOpacity={0} />
                </linearGradient> */}
                <linearGradient id="ruti" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#ff5722" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#ff5722" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="storage" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#00599D" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#00599D" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" stroke="gray" />
              <CartesianGrid
                strokeDasharray="3 3"
                className="stroke-[#9c9a9a]"
              />
              <Tooltip />
              <Legend />
              <Area
                type="monotone"
                dataKey="IN"
                stroke="#739D00"
                fillOpacity={1}
                fill="url(#in)"
              />
              <Area
                type="monotone"
                dataKey="OUT"
                stroke="#ffc658"
                fillOpacity={1}
                fill="url(#out)"
              />
              <Area
                type="monotone"
                dataKey="Ira"
                stroke="#e91e63"
                fillOpacity={1}
                fill="url(#ira)"
              />
              <Area
                type="monotone"
                dataKey="Nati"
                stroke="#8e24aa"
                fillOpacity={1}
                fill="url(#nati)"
              />
              {/* <Area
                type="monotone"
                dataKey="Shahar"
                stroke="#9c27b0"
                fillOpacity={1}
                fill="url(#shahar)"
              />
              <Area
                type="monotone"
                dataKey="Ofek"
                stroke="#00bcd4"
                fillOpacity={1}
                fill="url(#ofek)"
              /> */}
              <Area
                type="monotone"
                dataKey="Ruti"
                stroke="#ff5722"
                fillOpacity={1}
                fill="url(#ruti)"
              />
              <Area
                type="monotone"
                dataKey="Storage"
                stroke="#00599D"
                fillOpacity={1}
                fill="url(#storage)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default Chart;
